import { PromotionsApi } from '../clients';
import { mapProfessionalPayout } from '../mappers';

export const getProfessionalPromotionPayouts = async (professionalId) => {
  const data = await PromotionsApi.getProfessionalPromotionPayouts(professionalId);
  const list = Array.isArray(data) ? data : data?.response ?? data?.data ?? [];

  return list.map(mapProfessionalPayout);
};
